export const UPDATE = 'exercise/update';
export const DELETE_ENTRY = 'exercise/deleteEntry';
export const UPDATE_ENTRY = 'exercise/updateEntry';
export const CREATE_ENTRY = 'exercise/createEntry';
